import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { HasPermissionService } from '../../service/has-permission/has-permission.service';
import { Message } from 'primeng/primeng';
import { DashboardUrlService } from '../../service/dashboard-url/dashboard-url.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-dashboard-financial',
  templateUrl: './dashboard-financial.component.html',
  styleUrls: ['./dashboard-financial.component.scss']
})

export class DashboardFinancialComponent implements OnInit{
  private financial_dashboard_id: number = 3;
  private disabilities_dashboard_id: number = 6;

  public dashboardOptions: any[]
  public selectedDashboardId: number;

  public dashboard_url: SafeResourceUrl = null;
  public msgs: Message[] = [];
  public loading: boolean = true;

  constructor(
    public translate: TranslateService,
    public hasPermissionService: HasPermissionService,
    public dashboardUrlService: DashboardUrlService,
    private sanitizer: DomSanitizer,
  ) { }

  ngOnInit(): void {
    this.dashboardOptions= [
      { name: 'Informe Financiero', value: this.financial_dashboard_id },
      { name: 'Informe de Incapacidades', value: this.disabilities_dashboard_id }
    ];

    this.selectedDashboardId = this.financial_dashboard_id;
    this.getDashboardURL(this.selectedDashboardId);
  };

  public onDashboardChange(event: any): void {
    const newDashboardId = event.value.value

    if (newDashboardId) {
      this.getDashboardURL(newDashboardId);
    }
  }

  public hasRole(rol: any): boolean {
    var r: boolean = false;
    var role = JSON.parse(localStorage.getItem('profile')).roles[0].id;
    if (role == rol) r = true;
    return r;
  }

  public hasPermission(permission: any): boolean {
    return this.hasPermissionService.hasPermission(permission);
  }

  public getDashboardURL(report_id: number): void {
    if (typeof report_id !== 'number') {
      console.error('Se intentó cargar un informe con un ID inválido:', report_id);
      return;
    }

    this.loading = true;
    this.dashboard_url = null;

    this.dashboardUrlService.getOneDashboardURL(report_id).toPromise().then(
      response => {
        const responseData = response.json();
        if (responseData && responseData.data && responseData.data.length > 0) {
          this.dashboard_url = 
          this.sanitizer.bypassSecurityTrustResourceUrl(responseData.data[0].url);
        } else {
          this.msgs = [];
          this.msgs.push({
            severity: 'warn',
            summary: 'Informe no disponible',
            detail: 'No se encontró una URL configurada para este informe.'
          });
        }
        this.loading = false;
      },
      error =>{
        this.msgs = [];
        this.msgs.push({ severity: 'error', summary: 'Error de conexión', detail: 'No se pudo comunicar con el servidor para cargar el informe.'});
        this.loading = false;
      }
    );
  }
}


// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/dashboard-financial/dashboard-financial.component.ts